import { render, staticRenderFns } from "./free-events-limit.vue?vue&type=template&id=e37345ae&scoped=true&"
import script from "./free-events-limit.vue?vue&type=script&lang=ts&"
export * from "./free-events-limit.vue?vue&type=script&lang=ts&"
import style0 from "./free-events-limit.vue?vue&type=style&index=0&id=e37345ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37345ae",
  null
  
)

export default component.exports